var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoRiskFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_4)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42822 406.426L215.066 38.1675C230.348 10.9327 269.551 10.9327 284.833 38.1675L491.472 406.426C506.433 433.09 487.163 466 456.588 466H43.3117C12.7372 466 -6.53335 433.09 8.42822 406.426ZM250 129C266.569 129 280 142.431 280 159V299C280 315.569 266.569 329 250 329C233.431 329 220 315.569 220 299V159C220 142.431 233.431 129 250 129ZM280 382C280 398.569 266.569 412 250 412C233.431 412 220 398.569 220 382C220 365.431 233.431 352 250 352C266.569 352 280 365.431 280 382Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRiskFill);
export default __webpack_public_path__ + "static/media/ico_risk_fill.a506e4907a7676deb49c5c74e80230ad.svg";
export { ForwardRef as ReactComponent };